import { LangContext } from '../context/LangContext'; 
import { DeviceContext } from '../context/DeviceContext'; 
import { useContext, useEffect, useRef, useState} from 'react';

import { FullpageContainer, FullpageSection } from '@shinyongjun/react-fullpage';
import '@shinyongjun/react-fullpage/css';
import '../css/fullPage.css'

import Navbar from './Navbar'
import Section1 from './Section1'
import Section2 from './Section2'
import Section3 from './Section3'
import Section4 from './Section4'
import Footer from './Footer'
import FixedMenu from './FixedMenu';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Metodium from './Metodium';

export default function DefaultSection() {

    const location = useLocation();
    
    const { selectLanguage } = useContext(LangContext);
    const { isMobile } = useContext(DeviceContext);

    const [activeIndex, setActiveIndex] = useState(isMobile ? 0 : 1);
    
    const sectionRefs = {
        1: useRef(null),
        2: useRef(null),
        3: useRef(null),
        4: useRef(null)
    };

    useEffect(() => {
        if(selectLanguage !== 'ENGLISH' || isMobile){
            return;
        }else{
            if(location.pathname === "/"){
                const scrollToSection = () => {                    
                    if (sectionRefs[activeIndex].current) {
                        console.log('ectionRefs[activeIndex].current');
                        window.scrollTo({
                            top: sectionRefs[activeIndex].current.offsetTop - 50,
                            behavior: 'smooth'
                        });
                    }
                }
                setTimeout(()=>{      
                    scrollToSection();
                }, 500)            
            }
        }
    },[location.pathname])


  return (
    <div>
        <>
        <Navbar sectionRefs={sectionRefs} setActiveIndex={setActiveIndex} />
        <Routes>            
            {/* <Route path="/metodium" element={
                <>
                    <Metodium />
                    <Footer/>
                </>
            } /> */}            
            <Route path="/" 
                //path={["/", "*"]} 
                element={
                <>
                    {
                        isMobile ? 
                            <FullpageContainer
                                key={selectLanguage}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                                transitionDuration={500}
                            >
                                <FullpageSection name="first">
                                    <div style={{ width: '100%'}}>
                                        <Section1 ref={sectionRefs[1]}/>
                                    </div>
                                </FullpageSection>
                                {/* <FullpageSection name="second" >
                                    <div style={{ width: '100%'}}>
                                        <Section2 ref={sectionRefs[2]} setActiveIndex={setActiveIndex} sectionRefs={sectionRefs}/>
                                    </div>
                                </FullpageSection> */}
                                <FullpageSection name="third" >
                                    <div style={{ width: '100%'}}>
                                        <Section3 ref={sectionRefs[3]}/>
                                    </div>
                                </FullpageSection>
                                {/* {
                                    selectLanguage === 'ENGLISH' ?
                                    <FullpageSection name="forth" >
                                        <div style={{ width: '100%'}} >
                                            <Section4 ref={sectionRefs[4]}/>
                                        </div>
                                    </FullpageSection> : []

                                } */}
                                <FullpageSection name="five" isAutoHeight>
                                    <div style={{ width: '100%'}}>
                                        <Footer/>
                                    </div>
                                </FullpageSection>
                            </FullpageContainer>
                    : 
                        <>
                            <FixedMenu/>
                            <Section1 ref={sectionRefs[1]} />
                            {/* <Section2 ref={sectionRefs[2]} setActiveIndex={setActiveIndex} sectionRefs={sectionRefs} /> */}
                            <Section3 ref={sectionRefs[3]} />
                            {/* <Section4 ref={sectionRefs[4]} /> */}
                            <Footer sectionRefs={sectionRefs} setActiveIndex={setActiveIndex} />
                        </>
                    }              
                </>
            }/>              
           </Routes>                    
        </>
    </div>
  )
}

